import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AdStatsService = {
  // Get overall ad statistics
  getAdStats: async () => {
    try {
      const response = await apiService.get(`/itouch/ad-stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad stats:", error);
      throw error;
    }
  },

  // Get most viewed ad
  getMostViewedAd: async () => {
    try {
      const response = await apiService.get(`/itouch/ad-stats/most-viewed-ad`);
      return response.data;
    } catch (error) {
      console.error("Error fetching most viewed ad:", error);
      throw error;
    }
  },

  // Get most active device
  getMostActiveDevice: async () => {
    try {
      const response = await apiService.get(`/itouch/ad-stats/most-active-device`);
      return response.data;
    } catch (error) {
      console.error("Error fetching most active device:", error);
      throw error;
    }
  },

  // Get device views with filters
  getDeviceViews: async ({
    macId,
    startDate,
    endDate,
  } = {}) => {
    try {
      const filterList = [];
      if (macId && macId.trim())
        filterList.push(`macId=${encodeURIComponent(macId.trim())}`);
      if (startDate)
        filterList.push(`startDate=${encodeURIComponent(startDate)}`);
      if (endDate)
        filterList.push(`endDate=${encodeURIComponent(endDate)}`);

      const filterString = filterList.length > 0 ? `?${filterList.join("&")}` : "";
      const response = await apiService.get(`/itouch/ad-stats/device-views${filterString}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching device views:", error);
      throw error;
    }
  },

  // Get summary for specific ad
  getAdSummary: async (adId) => {
    try {
      const response = await apiService.get(`/itouch/ad-stats/ad-summary/${adId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad summary:", error);
      throw error;
    }
  },

  // Get top ads with date range
  getTopAds: async ({
    startDate,
    endDate,
    top = 5,
  } = {}) => {
    try {
      const filterList = [];
      if (startDate)
        filterList.push(`startDate=${encodeURIComponent(startDate)}`);
      if (endDate)
        filterList.push(`endDate=${encodeURIComponent(endDate)}`);
      if (top)
        filterList.push(`top=${parseInt(top)}`);

      const filterString = filterList.length > 0 ? `?${filterList.join("&")}` : "";
      const response = await apiService.get(`/itouch/ad-stats/top-ads${filterString}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching top ads:", error);
      throw error;
    }
  },
};

export default AdStatsService;
